import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { IsAuthenticatedContext } from "context/IsAuthenticatedContext";

const PrivateRoute = ({ element }) => {
  const { isAuthenticated } = useContext(IsAuthenticatedContext);
  return isAuthenticated ? element : <Navigate to="/login" />;
};

export default PrivateRoute;
